import {Lang} from 'yougile-lang'

export const extensionItemDefaultTooltipOffset: [number, number] = [0, 8]

export const sortingOptionTopRatedKey = 'topRated'
export const sortingOptionMostInstalledKey = 'mostInstalled'
export const sortingOptionMostCommentedKey = 'mostCommented'
export const sortingOptionReleaseDate = 'releaseDate'

type ExtensionsSortingOptions = {key: string; text: string}

// NOTE: a getter function is used instead of a constant array
// to properly handle dynamic changes in the system language.
export const getSortingOptions = (): ExtensionsSortingOptions[] => [
  {
    key: sortingOptionMostInstalledKey,
    text: Lang.msg.extensions.gallery.sortingOptions.mostInstalled
  },
  {
    key: sortingOptionTopRatedKey,
    text: Lang.msg.extensions.gallery.sortingOptions.topRated
  },
  {
    key: sortingOptionMostCommentedKey,
    text: Lang.msg.extensions.gallery.sortingOptions.mostCommented
  },
  {
    key: sortingOptionReleaseDate,
    text: Lang.msg.extensions.gallery.sortingOptions.releaseDate
  }
]
